<app-page-loader [isVisible]="isLoaderVisible"></app-page-loader>
<router-outlet></router-outlet>
